import PropTypes from 'prop-types';
import React, { useState, useEffect, useCallback } from 'react';
import NumberFormat from 'react-number-format';
import { Input as TWInput, FormFooter, DropdownMenu, InputGroup, DropdownMenuContent, DropdownMenuTrigger, DropdownMenuItem, CardTitle, SimpleAlert, ListGroupItem, FormBody, Row, Col, Button, Label, FormGroup, DefaultTooltip, Tabs, TabsContent, TabsList, TabsTrigger, Card, CardHeader, CardContent, FormCard } from 'twyne-new.ui';

import { ChevronDown, CircleHelp } from 'lucide-react';
import { merge } from 'lodash';
import { toJS } from 'mobx';

import Formsy from '@Components/form-new/FormContainer'
import InfoTip from 'components/InfoTip';
import PopoverConfirmation from 'components/PopoverConfirmation';
import Input from 'components/form/Input';
import InputDecimal from 'components/form/InputDecimal';
import Select from 'components/form/Select';
import Slider from 'components/form/Slider';
import Switch from 'components/form/Switch';
import SwitchCustom from 'components/form/SwitchCustom';
import siteStore from 'modules/admin/stores/site';
import formStore from 'modules/offer/stores/form';
import appStore from 'stores/app';
import history from 'utils/history';

import SelectForm from '../../../../cms/views/post/components/SelectForm'
import CustomConversion from './CustomConversion'
import RevenueIntegrations from './RevenueIntegrations'
import SelectOffer from './SelectOffer'
import { useAllocationStore } from '../store';

import AttributesForm from './AttributesForm';
import Duplicated, { DEFAULT_DUPLICATE_LEAD, DEFAULT_DUPLICATE_LEAD_DAYS, DEFAULT_DUPLICATE_CLICK_DAYS } from './Duplicated';
import ScrubOptions from './ScrubOptions';
import RuleGroupItemWrapper from '@Components/pure/rules/RuleGroup/Item';

class AllocationForm extends React.Component {
  state = {
    verificationsSite: [],
    verifications: {},
    form_step: 0,
    mobile_form_step: 0,
    active: true,
    scrub_percent: 0,
    override_form_conversion: false,
    override_mobile_form_conversion: false,
    override_attributes: false,
    fraud_check: false,
    email_check: false,
    skip_dup_reg: false,
    offerOptions: [],
    publisherOptions: [],
    custom: {},
    conversion_steps: [],
    mobile_conversion_steps: [],
    overrideMobileForm: false,
    mobile_form_id: null,
    revenue: null,
    offers: [],
    activeTab: 'offer',
    payout_types: [
      { label: 'CPC', value: 'cpc' },
      { label: 'CPA', value: 'cpa' },
      { label: 'CPM', value: 'cpm' },
      { label: 'CPL', value: 'cpl' },
      { label: 'Custom', value: 'custom' },
    ],
  }

  getCheck = type => {
    const key = verificationsTypesMapping[type]
    const value = this.state[key] || false
    return [key, value]
  }

  get isAttribute() {
    return this.props.type === 'attributes'
  }

  get isDetails() {
    return this.props.type === 'details'
  }

  get isVerifications() {
    return this.props.type === 'verifications'
  }

  componentWillMount() {
    this.loadAll()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this.setState(state => ({ ...state, ...this.props.data }))
    }
  }

  loadAll = async () => {
    await this.load()
  }

  load = async () => {
    const { data } = this.props;

    if (data) {
      data.skip_dup_reg = data.skip_dup_reg || false
      this.setState(data);
      if (data.form_id) {
        await formStore.fetch(data.form_id, true).then(result => {
          const form = result.data

          if (data.override_form_conversion && data.form_step > form.step) {
            this.setState({ form_id: form.id })
          }
        })
      }
      const { mobile_form_id, override_mobile_form_conversion, mobile_form_step } = data;
      if (data.mobile_form_id) {
        this.setState({ mobile_form_id, override_mobile_form_conversion, mobile_form_step, overrideMobileForm: true });
      }
    }
  }

  loadOverrideData = async () => {
    await siteStore.fetch(appStore.currentSiteID);
    return siteStore.entity.object.throttling || {}
  }

  handleValidSubmit = model => {
    const throttling = { ...this.state.throttling || {}, ...model.throttling }
    if (throttling.options && throttling.options.threshold) {
      throttling.options.threshold = throttling.options.threshold / 100
    }
    this.props.handleSubmit(Object.assign(this.state, model, { throttling, revenue: this.parseRevenue() }));
  }

  parseRevenue = () => {
    const { revenue } = this.state

    if (!revenue) {
      return revenue
    }

    const { integrations, ...rest } = revenue

    if (!isRevenueIntegrations(integrations)) {
      return rest
    }

    return {
      ...rest,
      integrations: Object.entries(integrations).reduce((parsed, [id, value]) => {
        parsed[id] = Number(value) || 0
        return parsed
      }, {}),
    }
  }

  handleCancel = () => {
    if (this.props.onCancel) {
      this.props.onCancel();
    } else {
      history.goBack();
    }
  }

  handleCustomChange = (key, value) => {
    const obj = {}
    obj[key] = value || ''

    const custom = Object.assign(this.state.custom, obj);

    this.setState({ custom });
  };

  handleChangeSkipDupReg = event => {
    const skip_dup_reg = event.target.checked
    this.setState({ skip_dup_reg })
  }

  handleChangeMeta = value => {
    const { meta } = this.state || {}
    this.setState({ meta: merge({}, meta, value) })
  }

  handleChangeTab = activeTab => {
    this.setState({ activeTab })
  }

  handleChangePayoutType = option => {
    const payouttype = option.value

    this.setState(previousState => {
      const nextState = { payouttype }

      if (!(previousState.payouttype === 'cpa' && payouttype !== 'cpa')) {
        return nextState
      }

      if (previousState.custom_conversion?.enabled) {
        nextState.custom_conversion = { ...previousState.custom_conversion, enabled: false }
      }

      if (previousState.activeTab === 'custom-conversion') {
        nextState.activeTab = 'offer'
      }

      return nextState
    })
  }

  Offer = () => {
    const { lists: { offers: { useLoad, items } } } = useAllocationStore()
    const { offers, offerOptions } = this.state

    useLoad()

    const loadOfferOptions = async offers => {
      const offerOptions = offers.map(offer => ({
        value: offer.id, label: offer.name, lander: offer.lander, versions: offer.lander.versions.map(version => ({
          label: version.description,
          value: version.id,
          disabled: !version.active,
          lander: offer.lander,
        })),
      }));
      this.setState({ offerOptions });
    }

    useEffect(() => {
      loadOfferOptions(items)
    }, [items])

    return <Row>
      <Col size="12">
        <SelectOffer
          offers={offers}
          onChange={offers => this.setState({ offers })}
          offerOptions={offerOptions}
        />
      </Col>
    </Row>
  }

  Payout = () => {
    const dynamicLabel = this.state.cost_mode === "dynamic" ? 'Default' : ''

    const handleCost = option => {
      const cost_mode = option.value
      this.setState({ cost_mode })
    }

    return <>
      <Col size="3">
        <FormGroup >
          <div className='flex items-center gap-2'>
            <Label id="cost-mode">Cost Mode</Label>
            <InfoTip id='dynamic-cost' color="neutral" disabled>
              Dynamic cost mode will require on the user to send the paramater <strong>cost</strong> to the first call to user enroll.
            </InfoTip>
          </div>
          <Select name="cost_mode" clearable={false} options={COST_MODE_OPTIONS}
            value={this.state.cost_mode} handleOnChange={handleCost} required />
        </FormGroup>
      </Col>
      <Col size="3">
        <FormGroup>
          <Label>{dynamicLabel} Payout</Label>
          <InputDecimal name="payout" value={this.state.payout} required onChange={payout => payout && this.setState({ payout })} />
        </FormGroup>
      </Col>
      <Col size="3">
        <FormGroup>
          <Label>{dynamicLabel} Mobile Payout</Label>
          <InputDecimal name="mobile_payout" value={this.state.mobile_payout} required />
        </FormGroup>
      </Col>
    </>
  }

  Details = () => {
    const { lists: { publishers: { useLoad, items } } } = useAllocationStore()

    useLoad()

    const loadPublisherOptions = async publishers => {
      const publisherOptions = publishers.map(publisher => ({ value: publisher.id, label: publisher.name }));
      this.setState({ publisherOptions });
    }

    useEffect(() => {
      loadPublisherOptions(items)
    }, [items])

    if (!this.isDetails) {
      return null
    }

    const handleSlug = event => {
      const { value } = event.target
      const slug = value.replace(/[^a-zA-Z0-9\-._~]/g, '')
      this.setState({ slug })
    }

    return <Row>
      <Col size="3">
        <FormGroup>
          <Label>Description</Label>
          <Input name="description" value={this.state.description || ''} />
        </FormGroup>
      </Col>
      <Col size="3">
        <FormGroup>
          <Label>Publisher</Label>
          <Select name="publisher_id" options={this.state.publisherOptions} value={this.state.publisher_id} required />
        </FormGroup>
      </Col>
      <Col size="3">
        <FormGroup>
          <Label>Slug</Label>
          <TWInput value={this.state.slug || ''} onChange={handleSlug} placeholder="Auto-generated if empty" />
        </FormGroup>
      </Col>
      <Col size="3">
        <FormGroup>
          <Label>Payout Type</Label>
          <Select name="payouttype" handleOnChange={this.handleChangePayoutType} options={this.state.payout_types} value={this.state.payouttype} required />
        </FormGroup>
      </Col>
      <this.Payout />
      <Col size="3"></Col>
      <this.Checkers />
    </Row>
  }

  OverrideForm = () => {
    const { lists: { forms: { items, useLoad } } } = useAllocationStore()
    const { forms, formOptions, mobileFormOptions } = this.state

    useLoad()

    const loadFormOptions = async forms => {
      const update = { formOptions: [], mobileFormOptions: [] }

      forms.forEach(form => {
        const { allowed_on, device_type } = form

        if (allowed_on === null || allowed_on.includes('allocations')) {
          const option = { value: form.id, label: form.name, steps: form.step }

          if (device_type === null || device_type.includes('desktop')) {
            update.formOptions.push(option)

            if (this.state.form_id === form.id) {
              update.formConversionStepsOptions = [...Array(option.steps || 0)].map((_, index) => ({ value: index + 1, label: index + 1 }))
            }
          }

          if (device_type === null || device_type.includes('mobile')) {
            update.mobileFormOptions.push(option)

            if (this.state.mobile_form_id === form.id) {
              update.mobileConversionStepsOptions = [...Array(option.steps || 0)].map((_, index) => ({ value: index + 1, label: index + 1 }))
            }
          }
        }
      })

      this.setState({ ...update })
    }

    useEffect(() => {
      loadFormOptions(items)
    }, [items])

    return <Row>
      <Col size="12">
        <SelectForm forms={forms} onChange={forms => this.setState({ forms })}
          formOptions={formOptions} mobileFormOptions={mobileFormOptions} required />
      </Col>
    </Row>
  }

  Revenue = () => {
    const REVENUE_OPTIONS = [
      { label: 'All ingested revenue', value: 'all' },
      { label: 'Only inside a range', value: 'range' },
    ]

    const RANGE_OPTIONS = [
      { label: 'Hours', value: 'hours' },
      { label: 'Days', value: 'days' },
    ]

    const [data, setData] = useState({ ...this.state.revenue })

    useEffect(() => {
      if (!data.revenueMethod)
        handleChange('revenueMethod', 'all')
    }, [data])

    const updateRevenue = revenue => {
      setData(revenue)
      this.setState({ revenue })
    }

    const handleChange = (key, value) => {
      updateRevenue({ ...data, [key]: value })
    }

    function Dropdown({ value, onChange }) {
      useEffect(() => {
        if (!value) {
          onChange('hours')
        }
      }, [value, onChange])

      return <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button color='accent' className='flex items-center capitalize rounded-l-none'>
            {value}
            <ChevronDown size={12} />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          {RANGE_OPTIONS.map(({ label, value }) => <DropdownMenuItem key={value} onClick={() => onChange(value)}>
            {label}
          </DropdownMenuItem>)}
        </DropdownMenuContent>
      </DropdownMenu>
    }

    function itemDate(data, handleChange) {
      const { duration, unit } = data || {}

      return <>
        <InputGroup className="w-full">
          <Input required type='number' name="date-rule-value" validationErrors={{ isRequired: '' }}
            value={duration} onChange={value => handleChange('duration', value.target.value)} />
          <Dropdown value={unit} onChange={value => handleChange('unit', value)} />
        </InputGroup>
      </>
    }

    return <>
      <Row>
        <Col size='4'>
          <FormGroup>
            <Label>Revenue to consider</Label>
            <Select
              name="revenueMethod"
              options={REVENUE_OPTIONS}
              value={data.revenueMethod}
              handleOnChange={option => handleChange('revenueMethod', option.value)}
              required
              clearable={false}
            />
          </FormGroup>
        </Col>

        {data.revenueMethod == 'range' && <Col size='4'>
          <Label className="pb-0 mb-1">Range</Label>
          <RuleGroupItemWrapper>
            {itemDate(data, handleChange)}
          </RuleGroupItemWrapper>
        </Col>
        }
      </Row>

      <Row className='mt-4'>
        <Col size='6'>
          <RevenueIntegrations
            value={data.integrations}
            onChange={integrations => handleChange('integrations', integrations)}
          />
        </Col>
      </Row>
    </>
  }

  Checkers = () => <>
    <Col size="3">
      <FormGroup>
        <Label>Default</Label>
        <this.PopoverDefault>
          <div className='pointer-events-none'>
            <Switch
              name='default'
              value={this.state.default || false}
              onChange={() => { }}
              setValue={() => { }}
              onClick={e => {
                e.preventDefault()
                e.stopPropagation()
              }} />
          </div>
        </this.PopoverDefault>
      </FormGroup>
    </Col>
    <Col size="3">
      <FormGroup>
        <Label>Skip duplicated registration</Label>
        <SwitchCustom name="skip_dup_reg" handleOnChange={this.handleChangeSkipDupReg} value={this.state.skip_dup_reg || false} />
      </FormGroup>
    </Col>
    {appStore.site.domain_aliases.includes('*.') && <Col size="3">
      <FormGroup>
        <Label>Enable Multiple Domain</Label>
        <Switch name="mult_domain" value={this.state.meta?.multDomain?.enabled || false} setValue={value => this.handleChangeMeta({ multDomain: { enabled: value } })} />
      </FormGroup>
    </Col>}
  </>

  PopoverDefault = ({ children }) => {
    if (this.state.default) {
      return <PopoverConfirmation
        title="Unavailable option"
        trigger={children}
      >
        <h6>Each site must have at least one default allocation. Change another entry to default to disable this.</h6>
      </PopoverConfirmation>
    }

    return <>
      <PopoverConfirmation
        title="Are you sure you want to do that?"
        subtitle="All the organic traffic will be attributed automatically to this Allocation."
        yesAction={() => this.setState(state => ({ default: !state.default }))}
        trigger={children}
      />
    </>
  }

  Verification = ({ type, disabled }) => {
    const [name, value] = this.getCheck(type)
    return <Switch
      name={name}
      value={value}
      disabled={disabled}
      setValue={value => this.setState({ [name]: value })} />
  }

  StopRegistrationEmailTip = ({ type, id }) => {
    if (type !== 'email') {
      return null
    }

    return <DefaultTooltip content='A verification will be done a maximum of 2 times.' >
      <CircleHelp size={14} />
    </DefaultTooltip>
  }

  ConvertRegistration = ({ type, disabled }) => {
    const { verifications: { [type]: { convert_fraud } = {} } } = this.state
    const [_, check] = this.getCheck(type)

    if (type !== 'fraud') {
      return null
    }

    return <ListGroupItem>
      <div className='flex justify-between items-center gap-1'>
        <span className='font-semibold flex gap-1 items-center'>
          Convert Fraud
          <InfoTip id='convert-fraud'>Include fraud on the cost</InfoTip>
        </span>
        <Switch name={`verifications.${type}.convert_fraud`}
          value={convert_fraud || false} disabled={disabled || !check} />
      </div>
    </ListGroupItem>
  }

  StopRegistration = ({ type, disabled, id }) => {
    if (type === 'fraud') {
      return null
    }

    const [_, check] = this.getCheck(type)
    const { verifications: { [type]: { stop_registration } = {} } } = this.state

    return <ListGroupItem>
      <div className='flex justify-between items-center gap-1'>
        <span className='font-semibold flex gap-1 items-center'>
          Stop Registration
          <this.StopRegistrationEmailTip type={type} />
        </span>
        <Switch
          name={`verifications.${type}.stop_registration`}
          value={stop_registration || false}
          disabled={disabled || !check}
        />
      </div>
    </ListGroupItem>
  }

  ThrottlingPercent = ({ type, disabled, id }) => {
    if (type !== 'fraud') {
      return null
    }

    const { verifications: { [type]: { fraud_throttling = 100 } = {} } } = this.state
    const [value, setValue] = useState(fraud_throttling)

    return <ListGroupItem>
      <div className='flex flex-col justify-between gap-1'>
        <span className='font-semibold flex gap-1 items-center'>
          Throttling Percent
          <InfoTip>
            Set the percentage of traffic you would like to verify for fraud. This setting is for the allocation as a whole and does not take SIDS into consideration.
          </InfoTip>
        </span>
        <Slider name={`verifications.${type}.fraud_throttling`} min={0} max={100} value={value} setValue={setValue} />
        <label>
          <small>The fraud verification will be {value === 0 ? 'disabled for all' : value === 100 ? 'enabled for all' : `enabled for ${value}%`} of the allocations traffic.</small>
        </label>
      </div>
    </ListGroupItem>
  }

  BillableVerifications = () => {
    const { listSiteVerifications } = useAllocationStore()
    const { verificationsSite } = this.state

    const loadVerifications = useCallback(async () => {
      const verificationsSite = await listSiteVerifications()
      this.setState({ verificationsSite })
    }, [listSiteVerifications])

    useEffect(() => {
      loadVerifications()
    }, [loadVerifications])

    return <>
      {verificationsSite.map(({ cmsVerification: { name, type, active, id }, cost }, idx) => <Col size="6" key={idx}>
        <Card className='mb-2'>
          <CardHeader>
            <CardTitle>{name}</CardTitle>
            <this.Verification type={type} disabled={!active} />
          </CardHeader>
          <CardContent className='mt-2'>
            <this.ConvertRegistration type={type} disabled={!active} />
            <ListGroupItem>
              <div className='flex justify-between items-center gap-1'>
                <span className='font-semibold'>
                  Cost
                </span>
                <NumberFormat value={cost} displayType="text" thousandSeparator="," decimalSeparator="." prefix={'$'} decimalScale={5} fixedDecimalScale={false} />
              </div>
            </ListGroupItem>
            <this.StopRegistration id={id} type={type} disabled={!active} />
            <this.ThrottlingPercent id={id} type={type} disabled={!active} />
          </CardContent>
        </Card>
      </Col>)}
    </>
  }

  Verifications = () => <>
    <Row>
      <this.BillableVerifications />
      <Col size="6">
        <Card className="mb-2">
          <CardHeader>
            <CardTitle>ReCaptcha Check</CardTitle>
            <Switch name="registration_check" value={this.state.registration_check || false} />
          </CardHeader>
        </Card>
      </Col>
    </Row>
  </>

  DuplicateClick = () => {
    const duplicateClick = this.state.duplicate_click_days
    const siteDuplicateClick = siteStore.entity?.object?.duplicateClick

    return <>
      <Col size="12">
        <Duplicated
          title="Settings for duplicate clicks"
          fieldName="duplicate_click_days"
          fieldValue={duplicateClick}
          onChange={value => this.setState({ duplicate_click_days: value })}
        >
          <SimpleAlert>
            {siteDuplicateClick ? <span>
              The current site settings for duplicated click is <strong>{siteDuplicateClick} day{siteDuplicateClick <= 1 ? '' : 's'}</strong>.
            </span> : <span>
              The default settings for duplicated click is <strong>{DEFAULT_DUPLICATE_CLICK_DAYS} day{DEFAULT_DUPLICATE_CLICK_DAYS <= 1 ? '' : 's'}</strong>.
            </span>}
          </SimpleAlert>
        </Duplicated>
      </Col>
    </>
  }

  DuplicateLead = () => {
    const { meta } = this.state
    const { duplicateLead } = meta || {}
    const { rules } = duplicateLead || {}
    const siteDuplicateLead = toJS(siteStore.entity?.object?.meta?.duplicateLead?.rules)

    const handleChange = rules => {
      this.setState(state => {
        state.meta = state.meta || {}
        state.meta.duplicateLead = state.duplicateLead || {}
        state.meta.duplicateLead.rules = rules
        return state
      })
    }

    const getAlert = () => siteDuplicateLead?.groups[0].rules.map(({ key, value }, index) => {
      if (index === 0) return `The current site settings for duplicated leads is configured to mark as duplicated ${key}s within the ${value} days`
      return ` ${key}s within the ${value} days.`
    }).join(' and')

    return <>
      <Col size="12">
        <Duplicated
          title="Settings for duplicate leads"
          fieldName="duplicateLead"
          fieldValue={rules}
          onChange={handleChange}
        >
          <SimpleAlert>
            {siteDuplicateLead ? getAlert() : <>
              The default settings for duplicated leads is configured to mark as duplicated {DEFAULT_DUPLICATE_LEAD} within the {DEFAULT_DUPLICATE_LEAD_DAYS} days.
            </>}
          </SimpleAlert>
        </Duplicated>
      </Col>
    </>
  }

  DuplicateTab = () => <Row>
    <Col size="5">
      <FormGroup>
        <Label>Duplicate Level</Label>
        <Select required name="_"
          options={DUPLICATE_LEVEL_OPTIONS}
          value={this.state.meta?.duplicateLead?.level || 'site'}
          handleOnChange={option => this.handleChangeMeta({ duplicateLead: { level: option ? option.value : 'site' } })}
        />
      </FormGroup>
    </Col>
    {(this.state.payouttype === 'cpc' || this.state.payouttype === 'cpm') && <Col size="4">
      <FormGroup>
        <Label>
          Duplicate click behaviour
          <InfoTip id='duplicate-click'>
            Clicks and Leads: Mark as duplicate if the lead is duplicated data or duplicated click. <br />
            Clicks only: Mark as duplicate if the lead is duplicated click.<br />
            By default, we use the Clicks and Leads.
          </InfoTip>
        </Label>
        <Select
          name="duplicateMode"
          options={[{ label: 'Clicks Only', value: 'clicks_only' }, { label: 'Clicks and Leads', value: 'clicks_leads' }]}
          value={this.state.duplicateMode || 'clicks_leads'}
          clearable={false}
        />
      </FormGroup>
    </Col>}
    <Col size="3">
      <FormGroup>
        <Label>
          Convert Duplicate
          <InfoTip id='duplicate'>Include duplicates on the cost</InfoTip>
        </Label>
        <Switch name="convert_duplicate" value={this.state.convert_duplicate || false} />
      </FormGroup>
    </Col>
    <this.DuplicateClick />
    <this.DuplicateLead />
  </Row>

  CustomConversionTab = () => <Row>
    <Col size="12">
      <CustomConversion
        value={this.state.custom_conversion}
        onChange={custom_conversion => this.setState({ custom_conversion })}
      />
    </Col>
  </Row>

  ScrubTab = () => <ScrubOptions throttling={this.state.throttling} origin='allocation' loadOverrideData={this.loadOverrideData} payout={this.state.payout}>
    <Col size='6'>
      <FormGroup>
        <Label>Scrub Percent</Label>
        <Slider className='pt-3' name="scrub_percent" min={0} max={100} value={this.state.scrub_percent} />
      </FormGroup>
    </Col>
  </ScrubOptions>

  Attributes = () => {
    const { lists: { offers: { items } } } = useAllocationStore()
    const offerId = this.state.offers[0]?.id

    useEffect(() => {
      if (items.length && !this.state.offer) {
        const offer = items.find(({ id }) => id === offerId)
        offer && this.setState({ offer })
      }
    }, [items])

    return <AttributesForm
      offer={this.state.offer}
      custom={this.state.custom}
      override_attributes={this.state.override_attributes}
      onChange={state => this.setState(state)}
    />
  }

  BuildTabs = () => {
    const [tabs, setTabs] = useState([[]])
    const { id, payouttype } = this.state

    useEffect(() => {
      const tabs = [
        ['offer', 'Offer'],
        ['form', 'Form'],
        ['verifications', 'Verifications'],
        ['duplicateds', 'Duplicateds'],
        ['scrub', 'Scrub'],
        ['revenue', 'Revenue'],
      ]

      if (id) {
        tabs.push(['attributes', 'Attributes'])
      }

      if (payouttype === 'cpa') {
        tabs.push(['custom-conversion', 'Custom Conversion'])
      }

      setTabs(tabs)
    }, [id, payouttype])

    return <Row className='mt-4'>
      <Col size="12">
        <Tabs value={this.state.activeTab} onValueChange={this.handleChangeTab} forceMount size='sm'>
          <TabsList>
            {tabs.map(([key, label]) => <TabsTrigger key={key} value={key}>
                {label}
            </TabsTrigger>)}
          </TabsList>
          <TabsContent value='offer'>
            <this.Offer />
          </TabsContent>
          <TabsContent value="form">
            <this.OverrideForm />
          </TabsContent>
          <TabsContent value="verifications" className='pb-8'>
            <this.Verifications />
          </TabsContent>
          <TabsContent value="attributes">
            <this.Attributes />
          </TabsContent>
          <TabsContent value="duplicateds">
            <this.DuplicateTab />
          </TabsContent>
          <TabsContent value="scrub">
            <this.ScrubTab />
          </TabsContent>
          <TabsContent value="revenue">
            <this.Revenue />
          </TabsContent>
          <TabsContent value="custom-conversion">
            <this.CustomConversionTab />
          </TabsContent>
        </Tabs>
      </Col>
    </Row>
  }

  render() {
    return <Formsy onValidSubmit={this.handleValidSubmit} >
      <FormBody className='pb-30'>
        <FormCard title='Details'>
          <this.Details />
          <this.BuildTabs />
        </FormCard>
        <FormFooter className='bottom-10'>
          <Button type="submit" color='accent'>Save</Button>
          <Button onClick={this.handleCancel} variant='ghost'>Cancel</Button>
        </FormFooter>
      </FormBody>
    </Formsy >
  }
}

const isRevenueIntegrations = integrations => Boolean(integrations) && typeof integrations === 'object' && !Array.isArray(integrations)

const DUPLICATE_LEVEL_OPTIONS = [
  { label: 'Duplicate by site', value: 'site' },
  { label: 'Duplicate by publisher', value: 'publisher' },
  { label: 'Duplicate by allocation', value: 'allocation' },
]

const COST_MODE_OPTIONS = [
  { label: 'Static', value: 'static' },
  { label: 'Dynamic', value: 'dynamic' },
]

const verificationsTypesMapping = {
  fraud: 'fraud_check',
  email: 'email_check',
  phone: 'phone_check',
  postal: 'postal_check',
}

AllocationForm.propTypes = {
  handleSubmit: PropTypes.func,
  data: PropTypes.any,
  type: PropTypes.string,
};

export default AllocationForm;
